export default __webpack_public_path__ + "static/095-6b14fffeb7db93f709dc452d47499065.jpg";